import { Chip, Tooltip } from '@mui/material';
import { Palette } from '@/themes/themeOverrides/Palette';

export const ParameterChip = ({ label, tooltip = label }) => (
    <Tooltip title={tooltip} arrow classes={{ tooltip: 'tooltip-black' }}>
        <span>
            <Chip size='small' label={label} className='chip-small' sx={{ backgroundColor: Palette.gray.gray100, borderRadius: '6px' }} />
        </span>
    </Tooltip>
);
